module.exports = __webpack_public_path__ + "static/media/privacy_trust-entrepreneurs-network.eb1de37f.svg";